const BotIcon = ({
  size = 24,
  color = "#7F3DFF",
  strokeWidth = 2,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Head */}
      <rect x="4" y="8" width="16" height="10" rx="3" />

      {/* Eyes */}
      <circle cx="9" cy="13" r="1.2" fill={color} stroke="none" />
      <circle cx="15" cy="13" r="1.2" fill={color} stroke="none" />

      {/* Antenna */}
      <line x1="12" y1="4" x2="12" y2="8" />
      <circle cx="12" cy="3" r="1" fill={color} stroke="none" />

      {/* Side Ears */}
      <line x1="2" y1="11" x2="4" y2="11" />
      <line x1="20" y1="11" x2="22" y2="11" />
    </svg>
  );
};

export default BotIcon;
